import Layout from "../components/Layout";
import { syaratDanKetentuanMeta, defaultURL } from "../data/DataMetatags";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import Description from "../components/UserInterface/Description";
import { syaratDanKetentuanBreadcrumb } from "../data/DataBreadcrumb";
import { DataSyaratKetentuan } from "../data/DataSyaratKetentuan";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import HeadingComponent from "../components/UserInterface/HeadingComponent";

const syaratDanKetentuan = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={syaratDanKetentuanBreadcrumb} />
      <LayoutCenter column>
        <HeadingComponent headingText="Syarat dan Ketentuan"></HeadingComponent>
        <Description
          align="left"
          font="Roboto"
          text={DataSyaratKetentuan.text}
        ></Description>
      </LayoutCenter>
      <style jsx>
        {`
          .things {
            width: 100px;
            height: 100px;
            border: solid 1px black;
            margin: 0 10px;
          }
        `}
      </style>
    </Layout>
  );
};

syaratDanKetentuan.getInitialProps = ({ asPath }) => {
  const pageTitle = syaratDanKetentuanMeta.title;
  const descriptionSEO = syaratDanKetentuanMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default syaratDanKetentuan;
